/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Laundry } from './Laundry';
import {
    LaundryFromJSON,
    LaundryFromJSONTyped,
    LaundryToJSON,
} from './Laundry';
import type { Page } from './Page';
import {
    PageFromJSON,
    PageFromJSONTyped,
    PageToJSON,
} from './Page';

/**
 * 
 * @export
 * @interface PageableLaundries
 */
export interface PageableLaundries {
    /**
     * 
     * @type {Array<Laundry>}
     * @memberof PageableLaundries
     */
    result: Array<Laundry>;
    /**
     * 
     * @type {Page}
     * @memberof PageableLaundries
     */
    page: Page;
}

/**
 * Check if a given object implements the PageableLaundries interface.
 */
export function instanceOfPageableLaundries(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    isInstance = isInstance && "page" in value;

    return isInstance;
}

export function PageableLaundriesFromJSON(json: any): PageableLaundries {
    return PageableLaundriesFromJSONTyped(json, false);
}

export function PageableLaundriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageableLaundries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(LaundryFromJSON)),
        'page': PageFromJSON(json['page']),
    };
}

export function PageableLaundriesToJSON(value?: PageableLaundries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(LaundryToJSON)),
        'page': PageToJSON(value.page),
    };
}

